<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="left">
        <div class="type">
          <p v-for="(obj,index) in helpType" :key="index" :class="title==obj?'activeClass':''"
             @click="change(index,obj)">
            <span>{{ obj }}</span>
            <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="title==obj">
          </p>
        </div>
      </div>
      <div class="right">
        <template v-if="title=='注册'">
          <resHelp></resHelp>
        </template>
        <template v-else-if="title=='私信'">
          <chat></chat>
        </template>
        <template v-else-if="title=='预约'">
          <appointHelp></appointHelp>
        </template>
        <template v-else-if="title=='咨询'">
          <consulting></consulting>
        </template>
        <template v-else-if="title=='领取优惠券'">
          <coupon></coupon>
        </template>
        <template v-else-if="title=='修改预约'">
          <updateAppoint></updateAppoint>
        </template>
        <template v-else-if="title=='取消预约'">
          <cancelAppoint></cancelAppoint>
        </template>
        <template v-else-if="title=='修改预约申请'">
          <editApplication></editApplication>
        </template>
        <template v-else-if="title=='心理测试'">
          <test></test>
        </template>
        <template v-else-if="title=='绑定微信'">
          <bingWechat></bingWechat>
        </template>
        <template v-else-if="title=='收藏小程序'">
          <collection></collection>
        </template>
        <template v-else-if="title=='关注医生'">
          <followDoc></followDoc>
        </template>
      </div>
    </div>
    <el-backtop target=".contentHome" :bottom="100" :visibility-height="10">
      <div
          style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      }"
      >
        UP
      </div>
    </el-backtop>
  </div>
</template>

<script>

import resHelp from './user/resHelp'
import appointHelp from './user/appointHelp'
import chat from './user/chat'
import consulting from './user/consulting'
import coupon from './user/coupon'
import updateAppoint from './user/updateAppoint'
import cancelAppoint from './user/cancelAppoint'
import editApplication from './user/editApplication'
import test from './user/test'
import bingWechat from './bingWechat'
import collection from './collection'
import followDoc from './user/followDoc'

export default {
  name: "helpCenter",
  data() {
    return {
      helpType: ["注册", "关注医生", "私信", "预约", "咨询", "领取优惠券", "修改预约", "取消预约", "修改预约申请", "心理测试", '绑定微信', '收藏小程序'],
      title: ''
    }
  },
  mounted() {
    if (this.$route.query.smallTit) {
      this.title = this.$route.query.smallTit
    } else {
      this.title = this.helpType[0]
    }
  },
  components: {
    resHelp, appointHelp, chat,
    consulting, coupon, updateAppoint,
    cancelAppoint, editApplication, test,
    bingWechat, collection, followDoc
  },
  methods: {
    change(index, tit) {
      this.active = index;
      this.title = tit
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/helpCenter.scss";
</style>
